import { render, staticRenderFns } from "./Pulmikort.vue?vue&type=template&id=1570c920&scoped=true"
import script from "./Pulmikort.vue?vue&type=script&lang=js"
export * from "./Pulmikort.vue?vue&type=script&lang=js"
import style0 from "./Pulmikort.vue?vue&type=style&index=0&id=1570c920&prod&lang=scss&scoped=true"
import style1 from "./Pulmikort.vue?vue&type=style&index=1&id=1570c920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1570c920",
  null
  
)

export default component.exports